module.exports = __webpack_public_path__ + "img/11.83228b84.jpg";